export default __webpack_public_path__ + "static/media/joke-icon.dffc462b.jpeg";